var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sections)?_c('div',_vm._l((_vm.sections),function(section){return _c('div',{key:section.id || section.title},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(section.title))]),_c('StatsScreenTree',{attrs:{"value":section.tree}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }